/**
 * Store pour les statistiques des publications par horaire de l'utilisateur connecté
 */

import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import axios from '@js/tools/axios';
/***/
import { useManagingUser } from '@compositions/ManagingUser';

export const useAuthSchedulePublicationStatisticsStore = defineStore('authSchedulePublicationStatistics', (() => {

    // Composition pour l'utilisateur que l'on gère
    const { getManagingUser } = useManagingUser({});

    // Données des statistics pour chaque heure et chaque jour
    const scheduleStatistics = ref(null);

    // Retourne les données des statistiques
    const getSchedulePublicationsStatistics = computed(() => (scheduleStatistics.value ?? []));

    /**
     * Chargement des statistiques des publications par horaire de l'utilisateur connecté
     * @return Promise
     */
    const loadSchedulePublicationsStatistics = (() => {

        if(scheduleStatistics.value !== null) {
            return Promise.resolve();
        }

        const userId = getManagingUser.value.id;

        const path = `/api/users/${ userId }/tasks/publications/statistics/schedule`;
        return axios.get(path).then((response) => {
            if(response && response.data && response.data.success && response.data.statistics) {
                scheduleStatistics.value = response.data.statistics;

                return Promise.resolve();
            }
            return Promise.reject();
        });

    });

    /**
     * Réinitialisation des données du store
     * @return void
     */
    const reset = (() => {
        scheduleStatistics.value = null;
    });

    return {
        getSchedulePublicationsStatistics,
        loadSchedulePublicationsStatistics,
        reset
    };
}));


